import axios from 'axios';

export const taskService = {
    createTaskService: (body) => axios.post('/task', body, { auth: true }),

    getTasksService: (params) => axios.get('/task', { auth: true, params: { ...params } }),

    getTaskByIdService: (id) => axios.get(`/task/${id}`, { auth: true }),

    updateTaskService: (id, body) => axios.patch(`/task/${id}`, body, { auth: true }),

    deleteTaskService: (id) => axios.delete(`/task/${id}`, { auth: true }),

    bulkUpdateStatusService: (body) => axios.post('/task/bulk/status', body, { auth: true }),

    bulkAssignService: (body) => axios.post('/task/bulk/assign', body, { auth: true }),

    bulkDeleteService: (body) => axios.post('/task/bulk/delete', body, { auth: true }),

    createCommentService: (taskId, body) => axios.post(`/task/${taskId}/comment`, body, { auth: true }),

    getCommentsService: (taskId, params) => axios.get(`/task/${taskId}/comment`, { auth: true, params: { ...params } }),

    deleteCommentService: (taskId, commentId) => axios.delete(`/task/${taskId}/comment/${commentId}`, { auth: true }),
};
